import type {PaymentDetailsLineType} from 'constants/flow/flowTypesCheckout';

/**
 * Make data be structured as needed in paymentDetails object
 * @param {string} label - for payment line
 * @param {string | number} value - for payment line
 * @param {string} currency - for payment line
 * @returns {PaymentDetailsLineType} - structured payment data
 */
export const paymentDetailsItemStructure = (
    label: string,
    value: string | number,
    currency: string = 'USD',
): PaymentDetailsLineType => ({
    label,
    amount: {value, currency},
});
